import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 14 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.083 6.74h-1.934V4.035C11.146 1.807 9.256 0 6.921 0S2.696 1.804 2.696 4.032v2.704H.921c-.508 0-.921.394-.921.879v9.506c0 .485.413.879.92.879h12.16c.508 0 .92-.394.92-.879V7.618c.004-.485-.409-.879-.917-.879m-5.157 7.052c0 .485-.412.879-.92.879-.509 0-.921-.394-.921-.88V11.18c0-.486.412-.88.92-.88.509 0 .921.394.921.88zm1.382-7.053h-4.77V4.036c0-1.255 1.068-2.275 2.383-2.275s2.383 1.02 2.383 2.275z" }, null, -1)
  ])))
}
export default { render: render }